import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Heading from '@cotyorg/ccx-atoms/Heading';
import CountriesList from './CountriesList';
import { MAX_COUNTRIES } from './constants';

const generateColumnClassNames = countries => classNames('cell', {
  'large-4': Array.isArray(countries) && countries.length <= MAX_COUNTRIES,
  'large-8': Array.isArray(countries) && countries.length > MAX_COUNTRIES,
});

const generateListClassNames = countries => classNames(
  'col',
  'no-bullet',
  'countries-wrapper__list', {
    'grid-x': Array.isArray(countries) && countries.length > MAX_COUNTRIES,
  },
);

const generateGridClassNames = ({ gridPadding }) => classNames(
  'grid-x',
  'align-justify',
  {
    'grid-padding-x': gridPadding,
  },
);

const CountriesWrapper = ({
  regions,
  gridPadding,
  isServedFromLegacySite,
}) => (
  <div className="countries-list">
    <div className="grid-container">
      <div className={generateGridClassNames({ gridPadding })}>
        {Array.isArray(regions) && regions.map(({ name, slug, countries }) => (
          <div key={slug} className={generateColumnClassNames(countries)}>
            <Heading extraClass="countries-wrapper__region-title" level={4}>
              {name}
            </Heading>
            <ul className={generateListClassNames(countries)}>
              <CountriesList countries={countries} isServedFromLegacySite={isServedFromLegacySite} />
            </ul>
          </div>
        ))}
      </div>
    </div>
  </div>
);

CountriesWrapper.propTypes = {
  regions: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    countries: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      langs: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      })),
    })),
  })).isRequired,
  gridPadding: PropTypes.bool,
  isServedFromLegacySite: PropTypes.bool,
};

export default CountriesWrapper;
